// extracted by mini-css-extract-plugin
export default {"faqAnswer":"FaqAnswerContent_faqAnswer__ZCe0R"};